import React from 'react';

import styled from '@emotion/styled';
import { DropdownMenu, Field, Radio } from '@rtkwlf/fenrir-react';

export interface RadioButtonListDropdownMenuItemOption<ValueType> {
  label: string;
  value: ValueType;
}

export interface RadioButtonListDropdownMenuItemProps<ValueTypes> {
  title: string;
  options: RadioButtonListDropdownMenuItemOption<ValueTypes>[];
  defaultValue: string;
  onValueChange: (value: ValueTypes) => void;
}

const StyledField = styled(Field.Root)({
  gap: 0,
});

const StyledRadio = styled(Radio.Root)({
  margin: 0,
});

export const RadioButtonListDropdownMenuItem = <T extends string>({
  title,
  options,
  defaultValue,
  onValueChange,
}: RadioButtonListDropdownMenuItemProps<T>) => {
  return (
    <StyledField>
      <Field.Info display="flex" paddingX="smedium" marginY="xsmall">
        {title}
      </Field.Info>

      <Field.Content marginBottom="small">
        <StyledRadio
          alignItems="center"
          defaultValue={defaultValue}
          gap="zero"
          width="full"
        >
          {options.map((option) => (
            // using DropdownMenu.Item here to allow keyboard navigation
            // radio navigation doesn't work as expected inside DropdownMenu
            <DropdownMenu.Item
              key={option.value}
              onSelect={() => onValueChange(option.value)}
              // disable role menuitem so that it doesn't conflict with Radio buttons
              role="none"
              height="auto"
              paddingY="small"
            >
              <Radio.Item value={option.value}>
                <Radio.ItemText cursor="pointer">{option.label}</Radio.ItemText>
              </Radio.Item>
            </DropdownMenu.Item>
          ))}
        </StyledRadio>
      </Field.Content>
    </StyledField>
  );
};
